import { render, staticRenderFns } from "./sup-cardsetting-ewalletid.vue?vue&type=template&id=4ca46db6"
import script from "./sup-cardsetting-ewalletid.vue?vue&type=script&lang=js"
export * from "./sup-cardsetting-ewalletid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports